import { HostEnvironmentOverride } from '@typesApp/Environment'
import cle_override from '../__data/cle/environment-override.json'
import vde_override from '../__data/vde/environment-override.json'
import { getLocalConfig } from './getLocalConfig'

const ENVIRONMENT_OVERRIDE = {
  cle: cle_override,
  vde: vde_override,
}

const LOCAL_CONFIG = getLocalConfig()

export const getEnvironmentOverride = (): HostEnvironmentOverride | undefined => {
  const brand = window.directBilling?.env?.brand
  if (brand) {
    return {
      ...ENVIRONMENT_OVERRIDE[brand],
      lang: LOCAL_CONFIG?.lang ?? ENVIRONMENT_OVERRIDE[brand]?.lang,
    }
  }
}